import { render } from "./VideoPlayerBottomBar.vue?vue&type=template&id=71c51415&ts=true"
import script from "./VideoPlayerBottomBar.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerBottomBar.vue?vue&type=script&lang=ts"

import "./VideoPlayerBottomBar.vue?vue&type=style&index=0&id=71c51415&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__